import { Record, List, OrderedMap } from 'immutable';
import { sortByNumbersAndName, sortProp } from 'domain/companies';

import { backupConnectionTypes, backupConnectionStatus } from 'domain/contracts';
import { FeatureSetFactory } from 'domain/companies';

export const organizationListItemFactory = (data) => {
  const record = new Record({
    picture: '',
    name: '',
    id: '',
    notifications: 0,
  });
  return record(data);
};

export const organizationListAdapter = (list = []) => List(list).map((item) => organizationListItemFactory(item));

const contactTypeFactory = new Record({
  phone: '',
  first_name: '',
  last_name: '',
  email: '',
});

export const signerFactory = new Record({
  password: '',
  token_name: null,
  name: '',
});

export const signingsFactory = (data = {}) => {
  const signings = new Record({
    guid: '',
    tokens: new List(),
  });
  const record = signings(data);
  if (data.tokens) {
    return record.set('tokens', List(data.tokens.map((item) => signerFactory(item))));
  }
  return record;
};

export const ipWhitelistFactory = (data = {}) => {
  const ipWhitelist = new Record({
    ips: new List(),
  });
  const record = ipWhitelist(data || {});
  if (data?.ips) {
    return record.set('ips', List(data.ips));
  }
  return record;
};

export const organizationApiKeyFactory = new Record({
  key_name: '',
  ips: '',
  expiration: '',
  api_key: '',
});

export const OrganizationApiKeysAdapter = (apiKeysData = []) => new List(apiKeysData.map(organizationApiKeyFactory));

export function organizationAdapter(data) {
  const org = new Record({
    picture: '',
    name: '',
    city: '',
    country: '',
    contact: contactTypeFactory(),
    street: '',
    vat_number: '',
    is_paid: false,
    id: null,
    registration_number: '',
    signings: signingsFactory(),
    list: List(),
    sort: 'name',
    filter: '',
    currentOrganization: null,
    features: OrderedMap(),
    backupConnection: List(),
    whatsapp_phone: null,
    expiration_days: null,
    amounts_representation: '',
    loaded: false,
    apiKeys: List(),
    apiKeysLoaded: false,
    dateFormat: 'DD/MM/YYYY',
    domain: '',
    hint_domain: '',
    ip_whitelist: ipWhitelistFactory(),
  });
  const record = org(data);
  if (typeof data !== 'undefined') {
    return record
      .set('contact', contactTypeFactory(data.contact))
      .set('ip_whitelist', ipWhitelistFactory(data.ip_whitelist));
  }
  return record;
}

export function orgBackupConnectionAdapter(data) {
  return new Record({
    type: backupConnectionTypes[0],
    connection: backupConnectionStatus[0],
    name: null,
    username: null,
    error: null,
  })(data);
}

export function orgBackupConnectionsAdapter(data) {
  return new List(data.map(orgBackupConnectionAdapter));
}

export function organizationFeaturesAdapter(data) {
  return OrderedMap(data).mapEntries(([K, V]) => [K, FeatureSetFactory(V)]);
}

export function sortOrganizations(organizations, sort, notifications) {
  const list = organizations
    .map((item) => item.set('notifications', notifications.get(item.id, 0)))
    .toList()
    .sortBy(sortProp('name'));
  const filters = {
    messages: (a, b) => sortByNumbersAndName(b.notifications, a.notifications, b.name, a.name),
  };
  return filters[sort] ? list.sort(filters[sort]) : list;
}

export function filterOrganizations(organizations, term) {
  return organizations.filter((f) => ~f.get('name', '').toLocaleLowerCase().indexOf(term.toLocaleLowerCase()));
}
